import React from 'react';
import './policies.css';

function TermsAndConditions() {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Terms & Conditions</h1>

        <div className="policy-welcome-box">
          <p>
            Welcome to <strong>Mr White</strong>! By using our website and mobile app,
            you agree to the following terms:
          </p>
        </div>

        <div className="policy-section">
          <h2>1. User Accountability</h2>
          <p>
            You are responsible for your actions and conduct while using our services.
            Use our platform lawfully and respectfully, avoiding harassment,
            impersonation, or harmful content.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Payment Details</h2>
          <p>
            Payment information must be accurate. Any membership or subscription
            fees are your responsibility, and we reserve the right to modify fees
            with prior notice.
          </p>
        </div>

        <div className="policy-section">
          <h2>3. Account Termination</h2>
          <p>
            You can terminate your account anytime via the app or by contacting
            customer support at{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>.
            Upon termination, your data will be handled in accordance with our
            Privacy Policy.
          </p>
        </div>

        <div className="policy-section">
          <h2>4. Limitation of Liability</h2>
          <p>
            Mr White is not liable for any indirect or consequential damages
            arising from your use of our services. Use our platform and services
            at your own risk.
          </p>
        </div>

        <div className="policy-section">
          <h2>5. Changes to Terms</h2>
          <p>
            We may update these terms occasionally. Significant changes will be
            communicated via email or in-app notifications. Continued use of our
            services indicates acceptance of any modifications.
          </p>
        </div>

        <div className="policy-section">
          <h2>6. Age of Consent</h2>
          <p>
            You must be at least 18 years old to use our services. If you are
            under 18 years of age, you must have the consent of a parent or
            legal guardian.
          </p>
        </div>

        <div className="policy-section">
          <h2>7. Governing Law</h2>
          <p>
            These Terms & Conditions are governed by the laws of the
            United Arab Emirates (UAE). Any disputes arising from the use of our
            services will be handled in accordance with applicable UAE laws and
            regulations.
          </p>
        </div>

        <div className="policy-section">
          <h2>Contact Us</h2>
          <p>
            For questions, concerns, or requests regarding these Terms &
            Conditions, please contact:
          </p>

          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;